<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="aboutUs">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent>
						<span @click="toTopImg()">首页</span>
						<span class="arrow">></span>
						<span @click="barClick(0)">关于我们</span>
						<span class="arrow">></span>
						<span v-if="list[count1] && list[count1].menuName">{{ list[count1].menuName }}</span>
					</div>
				</div>
				<div class="tabbar">
					<div class="item" @click="barClick(index)" :class="{ active: count == item.menuId }"
						v-for="(item, index) in list">
						<div class="txt">{{ item.menuName }}</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="card">
					<!-- 富文本 2130 2183 2131 2132 2133 -->
					<div v-if="count == 2130 || count == 2183 || count == 2131" class="rich" v-html="formatRichText(text)"></div>
					<div class="development-history" v-else-if="count == 2132">
						<div class="date-range">{{ data }}</div>
						<div class="list" v-for="(item, index) in snckData" :ref="item.id">
							<div class="item" v-for="(item1, index1) in item">
								<div class="left">
									<div class="square"></div>
									<div class="line" v-if="index != snckData.length - 1 || index1 != item.length - 1">
									</div>
								</div>
								<div class="right">
									<div class="title" v-if="item1.contentTitle">{{ item1.contentTitle }}</div>
									<div class="description" v-html="item1.contentDescription"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="certificate-list" v-else-if="count == 2133">
						<div class="item" v-for="(item, index) in snckData">
							<img :src="webImg + item.contentImg + imgCut(305,381)" alt="" @dragstart.prevent>
							<div v-if="item.contentTitle">{{ item.contentTitle }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="aboutUs">
				<!-- <div ref="pronbit">1111</div> -->
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent> <span @click="toTopImg()"
							style="cursor: pointer;">首页</span>
						<span style="color: black;">></span> <span @click="barClick(0)">关于我们</span><span
							style="color: black;">></span><span v-if="list[count1] && list[count1].menuName">{{
								list[count1].menuName }}</span>
					</div>
				</div>
				<div class="main">
					<div class="left">
						<div class="top">关于我们</div>
						<div v-for="(item, index) in list" class="bar" :class="{ bar1: count == item.menuId }"
							@click="barClick(index)">{{
								item.menuName
							}}</div>

					</div>
					<!-- 历程 --><!-- 富文本 2130 2183 2131 2132 2133 -->
					<div class="right" v-if="count == 2132" style="padding-top: 120px;">
						<div class="mainSnakLine" v-for="(item, index) in snckData" :ref="item.id">
							<div class="mainSnakLine0"></div>
							<div class="mainSnakLine1" v-if="index % 2 == 0 && isShow1 > 2 * index"></div>
							<div class="mainSnakLine2" v-if="index % 2 != 0 && isShow1 > 2 * index"></div>
							<div class="mainBoxRight0" v-if="index % 2 == 0 && index != snckData.length - 1">
							</div>
							<div class="mainBoxRight"
								v-if="index % 2 == 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1">
							</div>
							<div class="mainBoxRight1"
								v-if="index % 2 == 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1">
							</div>
							<div class="mainBoxLeft0" v-if="index % 2 != 0 && index != snckData.length - 1"></div>
							<div class="mainBoxLeft"
								v-if="index % 2 != 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1"></div>
							<div class="mainBoxLeft1"
								v-if="index % 2 != 0 && index != snckData.length - 1 && isShow1 > 2 * index + 1">
							</div>
							<div v-if="index == 0" class="mainBoxData">{{ data }}</div>
							<div class="mianBox" v-for="(item1, index1) in item">
								<div class="mianBoxTitle" v-if="item1.contentTitle">{{ item1.contentTitle }}</div>

								<div class="mianBoxDescription" style="color:#0175c2;!important;font-weight: 600;"
									v-if="item1.contentDescription == '“合肥通用机械研究院”正式成为公司控股股东'"
									v-html="item1.contentDescription"></div>
								<div v-else class="mianBoxDescription" v-html="item1.contentDescription"></div>
							</div>

						</div>

					</div>
					<!-- 荣誉 -->
					<div v-else-if="count == 2133" class="right" style="padding: 0;">
						<div
							style=" width: 92%;border-bottom: 1px solid #ededed;display: flex;cursor: pointer;margin: 0 auto;margin-top: 10px;">
							<div @click="contentType = (index+1), barClick(4,2133)" class="typeStyle"
								:class="{ typeStyle1: contentType == (index+1) }" v-for="(item, index) in typeList"
								:key="index">{{ item }}
							</div>
						</div>
						<div class="rightMain">
							<div class="rightMainItem" v-for="(item, index) in snckData">
								<img :src="webImg + item.contentImg" alt="" @dragstart.prevent
									style="border: 0.5px solid #e5e5e5">
								<div v-if="item.contentTitle" class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
							</div>
							<!-- 							<div class="rightMainItem" v-for="(item, index) in snckData">
								<img :src="webImg + item.contentImg +  imgCut(240,300)" alt="" @dragstart.prevent
									style="border: 0.5px solid #e5e5e5">
								<div v-if="item.contentTitle">{{ item.contentTitle }}</div>
							</div> -->
						</div>
						<div v-if="snckData.length > 0"
							style="height: 130px;display: flex;align-items: center;justify-content: center;">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize"
								@current-change="handleCurrentChange">
							</el-pagination>
						</div>

					</div>
					<!-- 富文本 -->
					<div class="right ftRight" v-else v-html="formatRichText(text)"></div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import {
		menu,
		singleinfo,
		contentList,
		contentPage
	} from '../api/api'
	var num = 0;
	export default {
		name: 'aboutUsTemplate',
		data() {
			return {
				parentId: this.$route.query.parentId || '', //二级菜单数组id
				list: [], //二级菜单数组
				text: '', //富文本内容
				count: 0,
				count1: 0,
				colNum: 0,
				rowNum: 0,
				data: '',
				snckData: [],
				pageNum: 1,
				pageSize: 9,
				total: 0,
				menuId: '',
				isShow1: -1,
				interval: null,
				search: '',
				contentSort: '',
				type: '',
				img: '',
				contentType: 1,
				typeList: ['公司资质', '公司荣誉'],
				typeCount: 0
			}
		},
		mounted() {
			if (this.isMobile) {
				this.pageSize = 10
				this.$bus.$on('reachBottom', data => {
					if (this.count == 2132) {
						if (this.snckData.length && this.pageNum * this.pageSize < this.total) {
							this.pageNum++;
							this.getContentList(this.list[this.count].menuId, this.count)
						} else {
							this.$message({
								message: '没有更多了~',
								center: true,
								offset: window.screen.height / 2
							});
						}
					}
				});
			} else {

			}
			window.addEventListener('scroll', this.handleScroll, true)
		},
		beforeDestroy() {
			this.$bus.$off('reachBottom');
			clearInterval(this.interval)
		},
		created() {
			this.getList() //二级菜单数组
		},
		watch: {
			$route(to, from) {
				console.log(to, 'ppppp');
				this.count = to.query.num
				this.barClick(to.query.num)
			},

		},
		methods: {
			handleScroll() {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop > 240 + (this.isShow1 / 2) * 290 && this.isShow1 % 2 == 0 && new Date().getTime() - num >
					1000) {
					if (this.isShow1 % 2 == 0) {
						this.isShow1++
						setTimeout(() => {
							this.isShow1++
							num = new Date().getTime()
						}, 2000)
					}
				}
			},
			//首页
			toTopImg() {
				this.$router.push({
					path: '/home',
					query: {
						index: 0
					}
				})
			},
			//二级菜单数组
			getList() {
				menu(this.parentId).then(res => {
          console.log(res.data,'二级菜单数组')
					this.list = res.data
          if(this.$route.query.num){
            if(this.list.length>this.$route.query.num){
              this.count = this.list[this.$route.query.num].menuId
              this.count1 = this.$route.query.num
            }else{
              for (let i = 0; i < this.list.length; i++) {
                if(this.list[i].menuId == this.$route.query.num){
                  console.log("this.list[i].menuId",this.list[i].menuId)
                  this.count = this.$route.query.num
                  this.count1 = i
                }
              }
            }
          }

          //企业简介  股权架构  组织架构
					if (this.count == 2130 || this.count == 2183 || this.count == 2131) {
						// this.count = this.$route.query.num
						this.getSingleinfo(res.data[this.count1].cmsLink) //富文本
					}
          //发展历程 资质荣誉
					if (this.count == 2132 || this.count == 2133) {
						// this.count = this.$route.query.num
						this.getContentList(res.data[this.count1].menuId)
					}
					if (!this.$route.query.num) {
						this.getSingleinfo(res.data[0].cmsLink) //富文本
					}
				})
			},
			//富文本
			getSingleinfo(id) {
				singleinfo(id).then(res => {
					this.text = res.data.content
					console.log(res, 'getSingleinfo');
				})
			},
			//菜单点击
			barClick(index,menuId) {
        if(menuId){
          this.count = menuId
        }else {
          this.count = this.list[index].menuId
        }
				this.pageNum = 1
				if (this.count == 2130 || this.count == 2183 || this.count == 2131) {
					this.getSingleinfo(this.list[index].cmsLink) //富文本
				}
				if (this.count == 2132 || this.count == 2133) {
					this.getContentList(this.count)
				}

			},
			getContentList(menuId) {
				this.isShow1 = -1
				num = 1
				if (menuId == 2132) {
					this.menuId = menuId
					contentList(menuId).then(res => {
						if (res.data[0] && res.data[0].contentTitle) {
							this.data = res.data[0].contentTitle
						} else {
							this.data = ''
						}

						let dataArr = this.setTwoDimensionalArray(res.data.filter(item => item.contentSort != 1))
						this.snckData = this.setReverseArray(dataArr)
						this.isShow1 = 0
						num = 1
						// this.snckData = res.data
					})
				} else {
					this.menuId = menuId
					contentPage(this.pageNum, this.pageSize, menuId, this.search, this.contentSort, this.type, this.img,
						this.contentType).then(res => {
						if (!this.isMobile) {
							this.snckData = res.data;
						} else {
							if (this.pageNum == 1) {
								this.snckData = res.data;
							} else {
								this.snckData = this.snckData.concat(res.data);
							}
						}
						this.total = res.total
					})
				}

			},
			handleCurrentChange(e) {
				contentPage(e, this.pageSize, this.menuId, this.search, this.contentSort, this.type, this.img, this
					.contentType).then(res => {
					this.snckData = res.data
					this.total = res.total
				})
			},
			// 转化函数
			setTwoDimensionalArray(list) {
				const listResult = []; // 最终返回的二维数组
				for (let i = 0; i < Math.ceil((list.length / 2)); i++) {
					listResult[i] = [];
					for (let j = 0; j < 2; j++) {
						// 如果是最后一个板块
						if (i === (Math.ceil((list.length / 2)) - 1)) {
							if (Math.ceil((list.length % 2)) !== 0) {
								// 只有最后一个板块的数据在余数以内的才赋值
								if (j < Math.ceil((list.length % 2))) {
									listResult[i][j] = list[i * 2 + j];
								}
							} else {
								// 如果刚好整整一个板块，则全部附上值
								listResult[i][j] = list[i * 2 + j];
							}
						} else {
							listResult[i][j] = list[i * 2 + j];
						}
					}
				}
				return listResult;
			},
			//翻转数组
			setReverseArray(list) {
				list.forEach((item, index) => {
					if (index % 2 != 0) {
						item = item.reverse()
					}
				});
				return list;
			},
			initSnckLine: function() {
				// this.calColNum();

				if (this.data.length > 0) {
					this.calRowNum();
				}
			},

			// /**
			//  * 计算一行显示的列数
			//  */
			// calColNum: function () {
			//     this.colNum = 2
			// },

			/**
			 * 计算需要多少行显示完
			 */
			calRowNum() {
				var length = this.data.length;
				if (this.colNum > length) {
					this.rowNum = 1;
				} else {
					this.rowNum = Math.floor(length / this.colNum);

					if (length % this.colNum > 0) {
						this.rowNum++;
					}
				}

				this.initsSnckData();
			},
			/**
			 * 初始化蛇形展示数据
			 * 得到一个二位数组
			 */
			initsSnckData: function() {
				// var that = this;
				// var newArr = [];
				// if (this.rowNum == 1) {
				//     newArr.push(that.data);
				// } else {
				//     for (var i = 0; i <= that.data.length; i += that.colNum) {
				//         var arr = that.data.slice(i, i + that.colNum);
				//         newArr.push(arr);
				//     }
				// }

				// if (newArr.length > 0) {
				//     newArr.forEach(function (item, index) {
				//         newArr[index] = that.getRowData(item, index);
				//     });
				// }

				// that.snckData = newArr;
				// console.log(newArr)
			},
			getRowData: function(data, index) {
				return (index % 2) == 0 ? data : data.reverse();
			},
			getWczt: function(ztdm) {
				var className = '';
				switch (ztdm) {
					case 1: //已完成
						className = 'green';
						break;
					case 2: //未完成
						className = 'yellow'
						break;
					case 3: //未开始
						className = 'red'
						break;
				}

				return className;
			},
			formatRichText(html) { //控制富文本图片大小
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
						'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');

				newContent = newContent.replace(/\<img/gi,
					'<img style="max-width:95%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');


				return newContent;
			},
		}

	}
</script>

<style scoped lang="scss">
	.device-mobile {
		.aboutUs {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 9.466667rem;
			margin-bottom: 1.466667rem;

			// background: #F5F5F5;
			.navigation {
				width: 100%;
				// background: #F5F5F5;
				padding: 0 0.333333rem;

				.navigationItem {
					display: flex;
					align-items: center;
					padding-top: 0.36rem;
					// height: 1.066667rem;
					color: #1979b7;
					font-size: 0.333333rem;

					.arrow {
						color: #030303;
						margin: 0 0.133333rem;
					}

					img {
						width: 0.333333rem;
						height: 0.333333rem;
						margin-right: 0.133333rem;
					}
				}
			}

			.tabbar {
				width: 100%;
				height: 1.653333rem;
				display: flex;
				align-items: center;

				.item {
					position: relative;
					display: flex;
					flex-direction: column;
					margin-right: 0.4rem;

					&.active {
						.txt {
							font-size: 0.453333rem;
							font-weight: bold;
							color: #000000;
						}

						.line {
							display: block;
						}
					}

					.txt {
						font-size: 0.4rem;
						font-weight: 400;
						color: #000000;
					}

					.line {
						position: absolute;
						bottom: -0.266667rem;
						display: none;
						margin-top: 0.213333rem;
						width: 1.2rem;
						height: 0.053333rem;
						background: #007CC3;
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
					}
				}
			}

			.card {
				width: 100%;
				box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
				border-radius: 0px 0px 0px 0px;
				opacity: 1;

				.rich {
					background: #FFFFFF;
					padding: 10px;
					box-sizing: border-box;
					font-size: 0.213333rem;
					// font-size: 0.213333rem;

					p img {
						text-indent: 0 !important;
					}
				}

				.development-history {
					width: 100%;
					box-sizing: border-box;
					padding: 0.533333rem;

					.date-range {
						width: 2.666667rem;
						height: 0.853333rem;
						margin-bottom: 0.8rem;
						background: #0175C2;
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
						font-size: 0.4rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 0.853333rem;
						text-align: center;
					}

					.list {
						.item {
							display: flex;

							.left {
								position: relative;
								display: flex;
								flex-direction: column;
								align-items: center;
								margin-right: 0.4rem;

								.square {
									width: 0.32rem;
									height: 0.32rem;
									background: #FFFFFF;
									box-shadow: 0px 0.053333rem 0.053333rem 0px rgba(5, 89, 187, 0.25);
									border-radius: 0px 0px 0px 0px;
									opacity: 1;
									box-sizing: border-box;
									border: 0.053333rem solid #0175C2;
								}

								.line {

									width: 0.053333rem;
									height: 100%;
									background-color: #0175C2;
									opacity: 1;
								}
							}

							.right {
								.title {
									font-size: 0.373333rem;
									font-family: Microsoft YaHei-Regular, Microsoft YaHei;
									font-weight: 400;
									color: #000000;
									line-height: 0.373333rem;
								}

								.description {
									font-size: 0.32rem;
									font-family: Microsoft YaHei-Regular, Microsoft YaHei;
									font-weight: 400;
									color: #666666;
									// line-height: 0.32rem;
									padding: 0.266667rem 0;
									min-height: 1.333333rem;
									box-sizing: border-box;
								}
							}
						}
					}
				}

				.certificate-list {
					width: 100%;
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;

					.item {
						margin-bottom: 0.266667rem;
						width: 4.6rem;
						// height: 6.493333rem;
						// background: #FFFFFF;
						box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
						box-sizing: border-box;
						padding: 0.266667rem 0.266667rem 0;

						img {
							width: 100%;
							height: 5.066667rem;
							// max-height: 5.066667rem;
							// background-color: #d3d8de;
							object-fit: contain;
						}

						div {
							width: 100%;
							height: 1.146667rem;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 0.346667rem;
							font-family: Microsoft YaHei-Regular, Microsoft YaHei;
							font-weight: 400;
							color: #333333;
							// line-height: 1.146667rem;
							text-align: center;
						}
					}
				}
			}
		}
	}

	.device-pc {
		.aboutUs {
			width: 100vw;
			// display: flex;
			// justify-content: center;
			background: #F5F5F5;
			padding-bottom: 50px;
		}

		.main {
			display: flex;
			margin: 0 auto;
			width: 1300px;
			padding-top: 25px;

		}

		.left {
			// background: #FFFFFF;

			.top {
				width: 270px;
				height: 64px;
				background: url('../assets/bannerImg.png') no-repeat;
				background-size: 100%;
				font-size: 26px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.bar {
				width: 270px;
				height: 48px;
				background: #FFFFFF;
				border-bottom: 1px solid #EDEDED;
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #333333;
				display: flex;
				justify-content: center;
				align-items: center;
				box-sizing: border-box;
				cursor: pointer;
			}

			.bar1 {
				font-size: 18px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #0175C2;
				border-bottom: 1px solid #0175C2;
			}
		}

		.right {
			width: 925px;
			margin-left: 10px;
			min-height: 600px;
			background: #FFFFFF;
			padding: 10px;
			box-sizing: border-box;
		}

		.ftRight {
			p img {
				text-indent: 0 !important;
			}
		}

		.rightMain {
			display: flex;
			flex-wrap: wrap;
			padding-bottom: 20px;
			// justify-content: space-between;

			.rightMainItem {

				display: flex;
				flex-direction: column;
				// justify-content: center;
				align-items: center;
				margin-top: 50px;
				margin-left: 52px;
				cursor: pointer;
				// overflow: hidden;

				.title {
					width: 240px;
					font-size: 18px;
					font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					text-align: center;
				}

			}

			// .rightMainItem:hover {

			//     // transform: scaleX(20%);
			//     img {
			//         transition: transform 2s cubic-bezier(.23, 1, .32, 1);
			//         transform: scale(1.1);
			//     }
			// }

			img {
				width: 240px;
				height: 300px;
				margin-bottom: 20px;
				box-shadow: 0 0 16px 5px #E0DEDF;
				object-fit: contain;
				// transition: transform 2s cubic-bezier(.23, 1, .32, 1);

			}
		}

		/* html,body{
		height: 100%;
		padding:0px;
		margin: 0px;
		overflow: auto;
	} */


		.mainSnakLine {
			width: 558px;
			height: 2px;
			margin: 0 auto;
			margin-bottom: 290px;
			position: relative;
			display: flex;
			justify-content: space-around;
		}

		.mainSnakLine0 {
			width: 558px;
			height: 2px;
			background: #f4f4f4;
			position: absolute;
			top: 0px;
			left: 0px;
		}

		.mainSnakLine1 {
			width: 558px;
			height: 2px;
			background: #0175C2;
			position: absolute;
			top: 0px;
			left: 0px;
			animation: widthAni 2s linear infinite alternate;
			animation-iteration-count: 1;
		}

		.mainSnakLine2 {
			width: 558px;
			height: 2px;
			background: #0175C2;
			position: absolute;
			top: 0px;
			right: 0px;
			animation: widthAni 2s linear infinite alternate;
			animation-iteration-count: 1;
		}

		.mainBoxRight {
			position: absolute;
			width: 144px;
			height: 290px;
			border: 2px solid #0175C2;
			border-radius: 0 144px 144px 0;
			border-left: none;
			top: 0;
			right: -135px;
		}

		.mainBoxRight0 {
			position: absolute;
			width: 144px;
			height: 290px;
			border: 2px solid #f4f4f4;
			border-radius: 0 144px 144px 0;
			border-left: none;
			top: 0;
			right: -135px;
		}

		.mainBoxRight1 {
			position: absolute;
			width: 144px;
			height: 0px;
			background-color: #FFFFFF;
			bottom: -292px;
			z-index: 1;
			right: -135px;
			animation: heightAni 1s linear infinite alternate;
			animation-iteration-count: 1;
		}

		.mainBoxLeft0 {
			position: absolute;
			width: 144px;
			height: 290px;
			border: 2px solid #f4f4f4;
			border-radius: 144px 0 0 144px;
			border-right: none;
			top: 0;
			left: -135px;
		}

		.mainBoxLeft {
			position: absolute;
			width: 144px;
			height: 290px;
			border: 2px solid #0175C2;
			border-radius: 144px 0 0 144px;
			border-right: none;
			top: 0;
			left: -135px;
		}

		.mainBoxLeft1 {
			position: absolute;
			width: 144px;
			height: 0px;
			background-color: #FFFFFF;
			bottom: -292px;
			z-index: 1;
			left: -135px;
			animation: heightAni 1s linear infinite alternate;
			animation-iteration-count: 1;
		}


		@keyframes widthAni {
			from {
				width: 0px
			}

			to {
				width: 558px
			}
		}

		@keyframes heightAni {
			from {
				height: 294px
			}

			to {
				height: 0px
			}
		}

		.mianBox {
			width: 12px;
			height: 12px;
			background: #FFFFFF;
			box-shadow: 0px 4px 4px 0px rgba(5, 89, 187, 0.25);
			border: 2px solid #0175C2;
			margin-top: -6px;
			position: relative;

			.mianBoxTitle {
				position: absolute;
				font-size: 36px;
				margin-bottom: 28px;
				// text-align: center;
				font-weight: bold;
				top: -60px;
				left: -50px;
			}

			.mianBoxDescription {
				position: absolute;
				top: 30px;
				left: 50%;
				width: 200px;
				// overflow: hidden;
				transform: translate(-50%, 0%);
				display: flex;
				justify-content: center;
				align-items: center;
				// text-align: center;
				color: #666;
				font-size: 17px !important;
			}


		}

		.mainBoxData {
			position: absolute;
			left: -150px;
			top: -86px;
			width: 200px;
			height: 88px;
			background: #0175C2;
			font-size: 30px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #FFFFFF;
			border-bottom: 1px solid #0175C2;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.navigation {

			width: 100vw;
			background: #fff;
			display: flex;
			align-items: center;
			cursor: pointer;

			.navigationItem {
				width: 1300px;
				margin: 0 auto;
				display: flex;
				align-items: center;
				// margin-top: 15px;
				height: 36px;
				line-height: 36px;
				margin-bottom: 20px;
				padding-top: 15px;
				box-sizing: border-box;
				color: #1979b7;
				font-size: 20px;
			}

			img {
				width: 20px;
				height: 20px;
				margin-right: 7px;

			}



		}


		.content {
			width: 914px;
			// padding: 0px 13%;
			padding: 0 150px;
			// min-height: 100vh;
			background-color: white;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;

			.box {
				width: 200px;
				height: 88px;
				background: #0175C2;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 30px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.line1 {
			width: 100%;
			height: 1px;
			background-color: #0175C2;
			animation: widthAni 2s linear infinite alternate;
			animation-iteration-count: 1;
		}

		.line2 {
			width: 100%;
			height: 1px;
			align-self: flex-end;
			background-color: #0175C2;
			animation: widthAni 2s linear infinite alternate;
			animation-iteration-count: 1;
		}


		.line_qm {
			width: 200px;
			height: 200px;
			align-self: flex-end;
			margin-right: -100px;
			position: relative;
		}

		.line_qm1 {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			border: #0175C2 solid 1px;
			border-radius: 100px;
		}

		.line_qm2 {
			width: 50%;
			height: 100%;
			background-color: white;
			position: absolute;
			top: 0;
			left: 0;
		}

		.line_qm3 {
			width: 101%;
			height: 0px;
			background-color: white;
			position: absolute;
			bottom: -1px;
			left: 0;
			animation: heightAni 2s linear infinite alternate;
			animation-iteration-count: 1;
		}

		.line_qw {
			width: 200px;
			height: 200px;
			margin-left: -100px;
			position: relative;
		}

		.line_qw1 {
			width: 200px;
			height: 200px;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			border: #0175C2 solid 1px;
			border-radius: 100px;
		}


		.line_qw2 {
			width: 100px;
			height: 200px;
			background-color: white;
			position: absolute;
			top: 0px;
			right: -2px;
			bottom: 0px;
		}

		.line_qw3 {
			width: 200px;
			height: 0px;
			background-color: white;
			position: absolute;
			left: 0px;
			bottom: -1px;
			animation: heightAni 2s linear infinite alternate;
			animation-iteration-count: 1;
		}
	}

	.typeStyle {
		width: 150px;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		border: 1px solid #e5e5e5;
		border-bottom: none;
	}

	.typeStyle1 {
		background: #0175c2;
		color: #fff;
		border: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue